import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
const riskClassTimeSeriesData = require('./fakedata/risk_class_timeseries.json');

const RiskClassTimeSeries = () => {
    const [chartData, setChartData] = useState({
        options: {
            chart: {
                type: 'line',
                height: 350,
                toolbar: {
                    show: false
                }
            },
            colors: ['#FF4560', '#00E396', '#FEB019', '#008FFB', '#775DD0', '#FF66C3', '#00BFFF', '#546E7A'], 
            stroke: {
                width: 3 
            },
            xaxis: {
                categories: [],
                labels: {
                    rotate: -45,
                    rotateAlways: true
                }
            },
            yaxis: {
                title: {
                    text: 'Count'
                },
                labels: {
                    offsetX: -10,
                    formatter: function (val) {
                        return val.toLocaleString();
                    }
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val !== undefined && val !== null ? val.toLocaleString() : '';
                    }
                }
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center'
            }
        },
        series: []
    });

    const [selectedFormat, setSelectedFormat] = useState('Daily');

    useEffect(() => {
        updateChartData('Daily');
    }, []);

    const updateChartData = (format) => {
        let data;
        let categories;
        switch (format) {
            case 'Daily':
                data = [
                    { name: 'V1', data: riskClassTimeSeriesData.daily.map(item => item.V1.count) },
                    { name: 'V2', data: riskClassTimeSeriesData.daily.map(item => item.V2.count) },
                    { name: 'V3', data: riskClassTimeSeriesData.daily.map(item => item.V3.count) },
                    { name: 'V4', data: riskClassTimeSeriesData.daily.map(item => item.V4.count) },
                    { name: 'V5', data: riskClassTimeSeriesData.daily.map(item => item.V5.count) },
                    { name: 'V6', data: riskClassTimeSeriesData.daily.map(item => item.V6.count) },
                    { name: 'V7', data: riskClassTimeSeriesData.daily.map(item => item.V7.count) },
                    { name: 'V8', data: riskClassTimeSeriesData.daily.map(item => item.V8.count) }
                ];
                categories = riskClassTimeSeriesData.daily.map(item => item.date);
                break;
            case 'Weekly':
                data = [
                    { name: 'V1', data: riskClassTimeSeriesData.weekly.map(item => item.V1.count) },
                    { name: 'V2', data: riskClassTimeSeriesData.weekly.map(item => item.V2.count) },
                    { name: 'V3', data: riskClassTimeSeriesData.weekly.map(item => item.V3.count) },
                    { name: 'V4', data: riskClassTimeSeriesData.weekly.map(item => item.V4.count) },
                    { name: 'V5', data: riskClassTimeSeriesData.weekly.map(item => item.V5.count) },
                    { name: 'V6', data: riskClassTimeSeriesData.weekly.map(item => item.V6.count) },
                    { name: 'V7', data: riskClassTimeSeriesData.weekly.map(item => item.V7.count) },
                    { name: 'V8', data: riskClassTimeSeriesData.weekly.map(item => item.V8.count) }
                ];
                categories = riskClassTimeSeriesData.weekly.map(item => `Week ${item.week}`);
                break;
            case 'Monthly':
                data = [
                    { name: 'V1', data: riskClassTimeSeriesData.monthly.map(item => item.V1.count) },
                    { name: 'V2', data: riskClassTimeSeriesData.monthly.map(item => item.V2.count) },
                    { name: 'V3', data: riskClassTimeSeriesData.monthly.map(item => item.V3.count) },
                    { name: 'V4', data: riskClassTimeSeriesData.monthly.map(item => item.V4.count) },
                    { name: 'V5', data: riskClassTimeSeriesData.monthly.map(item => item.V5.count) },
                    { name: 'V6', data: riskClassTimeSeriesData.monthly.map(item => item.V6.count) },
                    { name: 'V7', data: riskClassTimeSeriesData.monthly.map(item => item.V7.count) },
                    { name: 'V8', data: riskClassTimeSeriesData.monthly.map(item => item.V8.count) }
                ];
                categories = riskClassTimeSeriesData.monthly.map(item => item.month);
                break;
            default:
                data = [
                    { name: 'V1', data: riskClassTimeSeriesData.daily.map(item => item.V1.count) },
                    { name: 'V2', data: riskClassTimeSeriesData.daily.map(item => item.V2.count) },
                    { name: 'V3', data: riskClassTimeSeriesData.daily.map(item => item.V3.count) },
                    { name: 'V4', data: riskClassTimeSeriesData.daily.map(item => item.V4.count) },
                    { name: 'V5', data: riskClassTimeSeriesData.daily.map(item => item.V5.count) },
                    { name: 'V6', data: riskClassTimeSeriesData.daily.map(item => item.V6.count) },
                    { name: 'V7', data: riskClassTimeSeriesData.daily.map(item => item.V7.count) },
                    { name: 'V8', data: riskClassTimeSeriesData.daily.map(item => item.V8.count) }
                ];
                categories = riskClassTimeSeriesData.daily.map(item => item.date);
        }

        setChartData({
            ...chartData,
            series: data,
            options: {
                ...chartData.options,
                xaxis: {
                    categories: categories,
                    title: {
                        text: 'Time'
                    },
                    labels: {
                        rotate: -45,
                        rotateAlways: true
                    }
                },
                yaxis: {
                    title: {
                        text: 'Count'
                    },
                    labels: {
                        offsetX: -20,
                        formatter: function (val) {
                            return val.toLocaleString();
                        }
                    }
                }
            }
        });
    };

    const handleFormatChange = (format) => {
        setSelectedFormat(format);
        updateChartData(format);
    };

    return (
        <Card className="risk-class-time-series">
            <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">
                    <b>Risk Class Time Series</b>
                </h4>
                <div className="flex-shrink-0">
                    <UncontrolledDropdown className="card-header-dropdown">
                        <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                            <span className="text-muted">{selectedFormat}<i className="mdi mdi-chevron-down ms-1"></i></span>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem onClick={() => handleFormatChange('Daily')}>Daily</DropdownItem>
                            <DropdownItem onClick={() => handleFormatChange('Weekly')}>Weekly</DropdownItem>
                            <DropdownItem onClick={() => handleFormatChange('Monthly')}>Monthly</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </CardHeader>
            <CardBody>
                <div id="riskClassTimeSeries" className="risk-class-time-series-chart-container">
                    <ReactApexChart dir="ltr"
                        options={chartData.options}
                        series={chartData.series}
                        type="line"
                        height="350"
                        className="apex-charts"
                    />
                </div>
            </CardBody>
        </Card>
    );
};

export default RiskClassTimeSeries;
